module.exports = __webpack_public_path__ + "static/media/qCode.d53ae8f9.svg";